import { Truck } from "lucide-react";
import React, { memo } from "react";
import { Badge } from "../../../../components/ui/common/badge";
import AddChemicalTransportRoute from "./AddChemicalTransportRoute";
import { ChemicalTransportContextProps, Transportation } from "./chemicalTransport.types";
import ChemicalTransportRouteItem from "./ChemicalTransportRouteItem";

interface ChemicalTransportProps extends ChemicalTransportContextProps {
  transportations?: Transportation[];
}

const ChemicalTransport: React.FC<ChemicalTransportProps> = ({
  transportations = [],
  ...context
}) => {
  const hasRoutes = transportations.length > 0;

  return (
    <div className="tw-border tw-border-dashed tw-border-primary/30 tw-rounded tw-p-2.5 tw-space-y-2 tw-bg-primary/5 tw-mt-1">
      <div className="tw-flex tw-items-center tw-justify-between">
        <div className="tw-flex tw-items-center tw-gap-1.5">
          <Truck className="tw-h-3 tw-w-3 tw-text-muted-foreground" />
          <span className="tw-text-[10px] tw-font-medium tw-text-foreground">Transport Routes</span>
          {hasRoutes && (
            <Badge variant="outline" className="tw-text-[9px] tw-h-4 tw-px-1">
              {transportations.length}
            </Badge>
          )}
        </div>
      </div>

      {transportations.map(route => (
        <ChemicalTransportRouteItem key={route._id} route={route} {...context} />
      ))}

      <AddChemicalTransportRoute {...context} />
    </div>
  );
};

export default memo(ChemicalTransport);
